/**
 * Investor Utilities
 *
 * Exports for investor-specific functionality.
 */

export {
  useAnalyzePitchDeck,
  type AnalyzePitchDeckInput,
  type AnalyzePitchDeckResult,
  type UseAnalyzePitchDeckReturn,
} from './pitch-deck-analysis';
